// extracted by mini-css-extract-plugin
export default {"noResults":"HelpSearchPage_noResults__P9ZSM"};